module.exports = __webpack_public_path__ + "static/media/rightTop.fb25c769.png";